<template>
  <div
    :class="{
      [$style.radioTable]: true,
      [$style.port]: el.is.port,
      [$style.phone]: el.is.phone,
      [$style.small]: el.is.small
    }"
  >
    <!-- table -->
    <table style="width:100%" cellspacing="0" cellpadding="0">
      <!-- thead -->
      <tr>
        <th v-for="head in form.tableHeads" :key="head.key">
          {{ head.label }}
        </th>
      </tr>
      <!-- tbody -->
      <tr v-for="input in form.inputs" :key="input.label">
        <td v-html="input.label"></td>
        <td
          v-for="option in input.options"
          :key="option.value"
          :class="{
            [$style.selectableTD]: true
          }"
          @click="onChange(option)"
        >
          <label
            :class="{
              [$style.circle]: true,
              [$style.circleNewDesign]: isNewDesign
            }"
            :for="input.label + option.value"
          >
            <img
              :src="getCheckedIcon"
              alt="item image"
              :class="$style.checkedIcon"
              v-show="isChecked(option)"
            />
            <!-- <input
              hidden
              type="radio"
              :name="input.name"
              :id="input.label + option.value"
          /> -->
          </label>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import store from '@/store'
export default {
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      checkedObj: {}
    }
  },
  computed: {
    // note: new design
    isNewDesign() {
      return store.getters.hausankerDesign
    },
    // note: new design
    getCheckedIcon() {
      if (this.isNewDesign) {
        return require('../../assets/images/checked_new.svg')
      } else {
        return require('../../assets/images/checked.svg')
      }
    },
    el() {
      return store.state.el
    }
  },
  methods: {
    isChecked(option) {
      return this.checkedObj[option.name] === option.value
    },
    onChange(option) {
      this.checkedObj[option.name] = option.value
      const data = {
        slideName: this.form.slideName,
        formName: option.formName,
        name: option.name,
        allValues: this.checkedObj,
        value: option.value
      }
      this.$emit('check', data)
    }
  },
  created() {
    this.checkedObj = this.form.allValues
  }
}
</script>

<style lang="scss" module>
@import '@/scss/variables.scss';

.radioTable {
  width: 100%;
  font-size: 16px;
  table-layout: fixed;
  tr {
    th {
      font-size: 16px;
      font-weight: 400;
      text-align: center;
    }
    td {
      text-align: left;
      // padding: 18px 0px;
      height: 69px;
    }
  }

  tr:not(:last-child) {
    td {
      border-bottom: 1px solid $color_grey_2;
    }
  }
  td {
    width: 90px;
  }
  td:first-child {
    width: auto;
  }
}
.selectableTD {
  cursor: pointer;
}

.checkedIcon {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 24px;
  width: 24px;
}

.circle {
  position: relative;
  margin: 0 auto;
  cursor: pointer;
  display: block;
  border-radius: 50%;
  border: 3px solid $color_grey_2;
  width: 24px;
  height: 24px;
}

// new design
.circleNewDesign {
  border: 3px solid $color_border_new;
}

// note: PORT
.port {
  tr td {
    height: 50px;
  }
  .circle {
    height: 20px;
    width: 20px;
  }
  .checkedIcon {
    width: 20px;
    height: 20px;
  }
}

// note: PHONE
.phone {
  font-size: 12px;

  tr th {
    font-size: 14px;
    padding: 10px;
  }
}

tr {
  width: 80px;
}

// note: SMALL
.small {
  &.radioTable {
    font-size: 10px;
  }
}
</style>
